<!--Footer Starts-->
<footer>
  <div class="container-fluid doNotPrint">
    <p class="copyright text-center">
      Copyright  &copy;  {{currentDate | date: 'yyyy'}}, All rights reserved, Mamontov Andrey. Version: <strong>{{version}}</strong>.
    </p>

  </div>
</footer>
<!--Footer Ends-->
